module.exports = __webpack_public_path__ + "img/hohlschnitt_oekograu_restpaste.ef232346.jpg";